export default __webpack_public_path__ + "static/media/cvod-RP13.b370ddc4.svg";